// extracted by mini-css-extract-plugin
export default {"appContainer":"AppContainer_appContainer__-jw78"};